@defer (when loaded()) {

  <ion-list class="content-width">
    @for (videoBoard of videoBoards(); track $index) {
      <ion-item>
        <ion-label>{{ videoBoard.name }}</ion-label>
      </ion-item>
    }
  
  </ion-list>
} @loading (minimum 0.6s) {
  <ion-loading></ion-loading>
}
